import React from "react";
import SocialIcons from "./SocialIcons";
import { useI18n } from "../i18n";

export const Contact = () => {
  const { t } = useI18n();

  // jsx
  return (
    <div className="contact">
      {/* footer */}

      <div className="contact-center">
        {/* info */}
        <article className="contact-info">
          <h2>{t.contact.title}</h2>
          <p>{t.contact.text}</p>
        </article>

        {/* icons */}
        <article className="social-icons" id="follow">
          <h4>{t.contact.social}</h4>
          <div className="social-icons-container">
            <SocialIcons />
          </div>
        </article>
      </div>
    </div>
  );
};
